import styled from 'styled-components';
import {
    Box,
    Toolbar,
    Drawer,
} from "@mui/material";

export const RootLayoutContainer = styled(Box) <{ $darkMode?: boolean; }>`
    display: flex;
    height: 100vh;
    overflow: auto;
    background: ${(props) => props.$darkMode ? '#121212' : '#fff'} !important;

    .appBar {
        // background: ${(props) => props.$darkMode ? 'linear-gradient(90deg,rgba(2, 42, 88, 1) 0%, rgba(27, 69, 95, 1) 50%, rgba(49, 78, 95, 1) 100%)' : 'linear-gradient(90deg,rgba(7, 83, 171, 1) 0%, rgba(50, 131, 179, 1) 50%, rgba(133, 220, 255, 1) 100%)'} !important;
    }

    .mainDiv {
        margin-top: 64px !important;
        overflow: auto;
        min-height: 93vh;
        // background: ${(props) => props.$darkMode ? '#4d5055' : '#f6f8fa'} !important;
        .pageContent {
            display: flex;
            width: 100%;

            .scrollableContent {
                flex: 1;
                padding: 24px;
            }
        }
    }
`;

export const ToolbarContainer = styled(Toolbar) <{ $darkMode?: boolean; }>`
    display: flex;
    justify-content: space-between;

    .leftSideHeaderContainer {
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .rightSideHeaderContainer {
        flex-grow: 0;
        align-self: end;
        display: flex;
        align-items: center;

        .currencyCode {
            margin-top: -58px;
            margin-right: 10px;
            font-size: 12px;
        }

        .darkModeBtn {
            margin-top: -62px;
            margin-right: 10px;
            width: 40px;
            height: 40px;
        }
    
        .settingsBtn {
            border-radius: 4px;
            padding: 5px;
            margin-top: -65px;

            .MuiAvatar-root.MuiAvatar-circular {
                // margin-top: -40px;
            }

            .userNameContainer {
                margin: 0px 0px 0px 10px;

                .userNameText {
                    font-size: 0.875rem !important;
                    font-weight: 600 !important;
                    color: #ffffffd9 !important;
                }

                .roleNameText {
                    font-size: 0.675rem !important;
                    font-weight: 500 !important;
                    color: #ffffffd9 !important;
                }
            }
        }
    }
`;

export const SideMenuDrawerContainer = styled(Drawer) <{ $darkMode?: boolean; }>`
    .MuiPaper-root.MuiPaper-elevation.MuiPaper-elevation0.MuiDrawer-paper.MuiDrawer-paperAnchorLeft.MuiDrawer-paperAnchorDockedLeft {
        // background: var(${(props) => props.$darkMode ? '--darkMantineHeaderBGColor' : '--mantineHeaderBGColor'}) !important;
        .drawerHeader {
            .appLogo {
                max-width: 70%;
                margin: 20px 0px;
            }
        }
    }

    .versionNum {
        position: absolute;
        bottom: 0;
        margin: 0px 0px 20px 0px;
        justify-self: anchor-center;
        color: var(--copyRightTextColor);
        font-size: 13px;
        line-height: 1;
        font-weight: 400;
        align-self: center;
    }
`;